import React, { useState, useEffect } from 'react';
import { Row, Col, ToggleButtonGroup, ToggleButton, Button } from 'react-bootstrap';
import { useStoreState } from 'easy-peasy';
import useSearchWithParams from "../../../../hooks/useSearchWithParams.jsx";
import Webapp2UsersStats from './ClientWebapp2TabComponent/Webapp2UsersStats.jsx';
import Webapp2ActivitiesStats from './ClientWebapp2TabComponent/Webapp2ActivitiesStats.jsx';
import Webapp2Groups from './ClientWebapp2TabComponent/Webapp2Groups.jsx';
import axios from '../../../../services/axios'
import HelperMetiers360 from "../../../../services/HelpersMetiers360";

const ClientWebapp2TabComponent = ({ setModalData, modalData, setModalShow, setIsSending, readOnly = false }) => {

    const { clientById } = useStoreState(state => state.clients);

    const { apiData } = useStoreState(state => state.actionSlugs);

    const [tabSelected, setTabSelected] = useState("activities");

    const [userStats, setUserStats] = useState(null);
    const [groups, setGroups] = useState(null);
    const [activitiesStats, setActivitiesStats] = useState(null);
    const [openCreateGroup, setOpenCreateGroup] = useState(null);

    const searchPlaceholder = tabSelected === "groups"
        ? 'Rechercher par nom ou code de groupe'
        : tabSelected === "activities"
            ? 'Rechercher par titre'
            : tabSelected === "users"
                ? 'Rechercher par mots-clés (pseudo, prénom, nom)'
                : undefined;

    const { searchInput, search, resetSearchBar } = useSearchWithParams({
        placeholder: searchPlaceholder,
        delay: 400,
    });

    useEffect(() => {
        resetSearchBar();
        if (tabSelected === "users" || tabSelected === "groups") {
            if (!userStats) {
                const getUrl = apiData.ACTIONS?.clients?.getProps?.getWebapp2UsersStats?.url?.replace('uniqueId', clientById.uniqueId);
                axios.get(getUrl)
                    .then(response => setUserStats(response))
            }
            if (!groups) {
                const getUrl = apiData.ACTIONS?.clients?.getProps?.getWebapp2Groups?.url?.replace('uniqueId', clientById.uniqueId);
                axios.get(getUrl)
                    .then(response => setGroups(response))
            }
        } else if (tabSelected === "activities" && !activitiesStats) {
            const getUrl = apiData.ACTIONS?.clients?.getProps?.getWebapp2ActivitiesStats?.url?.replace('uniqueId', clientById.uniqueId);
            axios.get(getUrl)
                .then(response => setActivitiesStats(response))
        }
    }, [tabSelected]);


    return <>
        <Row className='mb-3 d-flex justify-content-between'>
            <div className='w-auto'>
                {`Code${clientById?.webappAccesses?.length > 1 ? "s" : ""} webapp`} :&nbsp;
                <span className='w-auto fw-bold'>{clientById?.webappAccesses?.join(", ")}</span>
            </div>
            {clientById?.storiesViewCount >= 0 ?
                <div className="webapp2Counts w-auto">
                    <b>Stories vues :</b> {clientById?.storiesViewCount}
                </div>
                : null}
        </Row>
        <Row className="item-page align-items-center">
            <Col>
                {searchInput}
            </Col>
            <Col className="col-auto d-flex align-items-center gap-2">
                {tabSelected === "groups" && openCreateGroup && !readOnly &&
                    <Button variant="success" size="sm" onClick={openCreateGroup}>
                        <i className="fas fa-plus"></i>&nbsp;Nouveau
                    </Button>
                }
                <ToggleButtonGroup type="radio" name="option-view-webapp2" value={tabSelected} onChange={(val) => setTabSelected(val)}>
                    <ToggleButton value="activities" key="activities" id="activities-tab" checked={tabSelected === "activities"}>
                        Activités
                    </ToggleButton>
                    <ToggleButton value="users" key="users" id="users-tab" checked={tabSelected === "users"}>
                        Utilisateur·rices
                    </ToggleButton>
                    <ToggleButton value="groups" key="groups" id="groups-tab" checked={tabSelected === "groups"}>
                        Groupes
                    </ToggleButton>
                </ToggleButtonGroup>
            </Col>
        </Row>
        <Row>
            {tabSelected === "activities" && <Webapp2ActivitiesStats
                activitiesStats={activitiesStats?.length > 0
                    ? [...activitiesStats]?.filter(s => HelperMetiers360.isSearchInText(search, s.title))
                    : activitiesStats}
                clientById={clientById}
                setModalData={setModalData}
                modalData={modalData}
                setModalShow={setModalShow}
            />}
            {tabSelected === "users" && <Webapp2UsersStats
                userStats={userStats?.length > 0
                    ? [...userStats]?.filter(s => HelperMetiers360.isSearchInText(search, s.userName)
                        || HelperMetiers360.isSearchInText(search, s.firstName)
                        || HelperMetiers360.isSearchInText(search, s.lastName)
                        || HelperMetiers360.isSearchInText(search, s.email)
                    )
                    : userStats}
                setUserStats={setUserStats}
                setModalData={setModalData}
                modalData={modalData}
                setModalShow={setModalShow}
                setIsSending={setIsSending}
                clientById={clientById}
                groups={groups}
                setGroups={setGroups}
                readOnly={readOnly}
                displaySearchBar={false}
            />}
            {tabSelected === "groups" && <Webapp2Groups
                groups={groups?.length > 0 ? [...groups]?.filter(g =>
                    HelperMetiers360.isSearchInText(search, g.name)
                    || HelperMetiers360.isSearchInText(search, g.code)
                ) : groups}
                setGroups={setGroups}
                userStats={userStats}
                setUserStats={setUserStats}
                setModalData={setModalData}
                modalData={modalData}
                setModalShow={setModalShow}
                setIsSending={setIsSending}
                clientById={clientById}
                onCreateReady={(fn) => setOpenCreateGroup(() => fn)}
                readOnly={readOnly}
            />}
        </Row>
    </>
}

export default ClientWebapp2TabComponent;
